import { render, staticRenderFns } from "./GlobalSearchSingleResult.vue?vue&type=template&id=7fdfe9ae"
import script from "./GlobalSearchSingleResult.vue?vue&type=script&lang=js"
export * from "./GlobalSearchSingleResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fdfe9ae')) {
      api.createRecord('7fdfe9ae', component.options)
    } else {
      api.reload('7fdfe9ae', component.options)
    }
    module.hot.accept("./GlobalSearchSingleResult.vue?vue&type=template&id=7fdfe9ae", function () {
      api.rerender('7fdfe9ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/globalSearch/GlobalSearchSingleResult.vue"
export default component.exports